import { TransitionModule } from "./../transition/transition.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SpinnerComponent } from "./spinner.component";
import { FormsModule } from "@angular/forms";

@NgModule({
	declarations: [SpinnerComponent],
	imports: [CommonModule, FormsModule, TransitionModule],
	exports: [SpinnerComponent]
})
export class SpinnerModule { }
